import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthForm from "./components/AuthForm";
import LessonMenu from "./components/LessonMenu";
import LessonPage from "./components/LessonPage";
import LandingPage from "./components/LandingPage";
import Vocab from "./components/Vocab";
import CultureTips from "./components/CultureTips";
import Practice from "./components/Practice";
import AboutMe from "./components/AboutMe";
import Dashboard from "./components/Dashboard";
import UserProfile from "./components/UserProfile";
import Onboarding from "./components/Onboarding";
import ScrollToTop from "./components/ScrollToTop";

function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/dashboard" /> : children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          } />
          <Route path="/login" element={<AuthForm />} />
          <Route path="/lessons" element={<LessonMenu />} />
          <Route path="/lesson/:id" element={<LessonPage />} />
          <Route path="/vocab" element={<Vocab />} />
          <Route path="/practice" element={<Practice />} />
          <Route path="/culture" element={<CultureTips />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/profile" element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          } />
          <Route path="/onboarding" element={
            <PrivateRoute>
              <Onboarding />
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;